import {Totals} from '../../../../../common/components/Totals/Totals';
import {shorten} from '../../../../../domain/utils/shorten';
import React from 'react';
import {TotalsSectionDataHooks} from '../TotalsSection';
import {useLocaleKeys} from '../../../../../locale-keys/LocaleKeys';
import {useControllerProps} from '../../../Widget/ControllerContext';
import {CouponDiscountModel} from '../../../../../domain/models/checkout/CartSummary/CouponDiscount.model';
import {useEnvironment} from '@wix/yoshi-flow-editor';
import {formatSignedAmount, isFreeShippingCoupon} from '../../../../../domain/utils/total.util';
import {TotalUpdateSkeleton} from '../../TotalUpdateSkeleton';

export const CouponTotalsRow = () => {
  const localeKeys = useLocaleKeys();
  const {cart, cartSummary, isCartSummaryUpdating} = useControllerProps().checkoutStore;
  const {isRTL} = useEnvironment();

  if (!cart.coupon || !cartSummary!.couponDiscount || cartSummary!.errors.couponError) {
    return null;
  }

  const getCouponRowValueText = (coupon: CouponDiscountModel): string => {
    if (isFreeShippingCoupon(coupon)) {
      return localeKeys.checkout.order_summary.totals.discount.free_delivery();
    }

    return formatSignedAmount({amount: cartSummary!.priceSummary.discount.formattedAmount, isRTL});
  };

  return (
    <Totals.TotalsRow
      dataHook={TotalsSectionDataHooks.AppliedCouponRow}
      title={localeKeys.checkout.order_summary.totals.discount.$value({
        couponCode: shorten(cart.coupon.code.toUpperCase(), 10, '...'),
      })}
      value={isCartSummaryUpdating ? () => <TotalUpdateSkeleton /> : getCouponRowValueText(cartSummary!.couponDiscount)}
    />
  );
};
